module.exports = __webpack_public_path__ + "static/media/icon-infor.33fc4c82.svg";